import { render, staticRenderFns } from "./PcpGiftView.vue?vue&type=template&id=61c5931c&scoped=true"
import script from "./PcpGiftView.vue?vue&type=script&lang=js"
export * from "./PcpGiftView.vue?vue&type=script&lang=js"
import style0 from "./PcpGiftView.vue?vue&type=style&index=0&id=61c5931c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c5931c",
  null
  
)

export default component.exports